export default {

  // COMMON
  BG_COLOR: '#f3f3f3', // ufo grey,
  MAIN_COLOR: '#283D4C', // ufo dark blue
  MAIN_INVERTED_COLOR: '#ffffff', // white
  PRIMARY_COLOR: '#68a3c2', // ufo flash blue
  SECONDARY_COLOR: '#40667D', // UFO secondary
  DESCRIPTION_COLOR: '#9FB2BE',
  ATTENTION_COLOR: '#dc3545', // red
  SUCCESS_COLOR: '#40b844', // green
  WARNING_COLOR: '#ffc107', // orange

  // OTHER
  TRANSPARENT: 'transparent'

}
